import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
// import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
// import { MaterialReactTable } from 'material-react-table';
// import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

const ProductionDailyReportView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [daillyreportdata, setDaillyreportdata] = useState({});


  useEffect(() => {

    axios
      .get(`/daily-report/listing-new-details/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data);
          setDaillyreportdata(response.data.data.daily_reports);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(base_url)
  const handleDownload = async () => {
    //let season_id = localStorage.getItem("season_id");
    window.open(`${base_url}/daily-report-export/${id}`, '_blank');
  };


  console.log(daillyreportdata.valuess);

  const updateNonConform = async (daily_id) => {
    const current = value.valuess;

    const { value: formValues } = await Swal.fire({
      title: 'Update Non-Conform Product',
      html: `
      <div style="text-align:left; padding: 0 10px;">
        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">Grade A</label>
        <input type="number" id="grade_a" class="swal2-input" style="width: 100%;" placeholder="Grade A" min="0" value="${current?.grade_a ?? ''}">

        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">Grade B</label>
        <input type="number" id="grade_b" class="swal2-input" style="width: 100%;" placeholder="Grade B" min="0" value="${current?.grade_b ?? ''}">

        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">Crumble</label>
        <input type="number" id="crumble" class="swal2-input" style="width: 100%;" placeholder="Crumble" min="0" value="${current?.crumble ?? ''}">

        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">Puree</label>
        <input type="number" id="puree" class="swal2-input" style="width: 100%;" placeholder="Puree" min="0" value="${current?.puree ?? ''}">
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      customClass: 'swal-orders',
      focusConfirm: false,
      preConfirm: () => {
        const grade_a = document.getElementById('grade_a').value;
        const grade_b = document.getElementById('grade_b').value;
        const crumble = document.getElementById('crumble').value;
        const puree = document.getElementById('puree').value;

        if (!grade_a && !grade_b && !crumble && !puree) {
          Swal.showValidationMessage('Please fill in at least one field');
          return false;
        }

        return { grade_a, grade_b, crumble, puree };
      },
    });

    if (formValues) {
      axios
        .post(`/daily-report/update/${daily_id}`, formValues, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            // ✅ Update the value state after success
            setValue((prev) => ({
              ...prev,
              valuess: {
                ...prev.valuess,
                grade_a: formValues.grade_a || prev.valuess?.grade_a,
                grade_b: formValues.grade_b || prev.valuess?.grade_b,
                crumble: formValues.crumble || prev.valuess?.crumble,
                puree: formValues.puree || prev.valuess?.puree,
              },
            }));
            Swal.fire('Updated!', 'Values updated successfully.', 'success');

            axios
              .get(`/daily-report/listing-new-details/${id}`, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                if (response.data.code === 200) {
                  setValue(response.data.data);
                  setDaillyreportdata(response.data.data.daily_reports);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch(console.log);
    }
  };




  const updateConsumables = async (daily_id) => {
    // Get current values from the state
    const current = value.valuess;

    // Show SweetAlert modal with form fields for Consumables items
    const { value: formValues } = await Swal.fire({
      title: 'Update Consumables',
      html: `
      <div style="text-align:left; padding: 0 10px;">
        <!-- Cellophane input field -->
        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">Cellophane</label>
        <input type="text" id="cellophane" class="swal2-input" style="width: 100%;" placeholder="Cellophane" min="0" value="${current?.cellophane ?? '0'}">

        <!-- Scotch input field -->
        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">Scotch</label>
        <input type="text" id="scotch" class="swal2-input" style="width: 100%;" placeholder="Scotch" min="0" value="${current?.scotch ?? '0'}">

        <!-- PL 10 KG input field -->
        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">PL 10 KG</label>
        <input type="text" id="pl_10_kg" class="swal2-input" style="width: 100%;" placeholder="PL 10 KG" min="0" value="${current?.pl_10_kg ?? '0'}">

        <!-- PL 20 KG input field -->
        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">PL 20 KG</label>
        <input type="text" id="pl_20_kg" class="swal2-input" style="width: 100%;" placeholder="PL 20 KG" min="0" value="${current?.pl_20_kg ?? '0'}">

        <!-- Carton 10 KG input field -->
        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">Carton 10 KG</label>
        <input type="text" id="carton_10_kg" class="swal2-input" style="width: 100%;" placeholder="Carton 10 KG" min="0" value="${current?.carton_10_kg ?? '0'}">

        <!-- Carton 20 KG input field -->
        <label style="display:block; margin-bottom:4px; font-weight:600;padding-left: 8px;">Carton 20 KG</label>
        <input type="text" id="carton_20_kg" class="swal2-input" style="width: 100%;" placeholder="Carton 20 KG" min="0" value="${current?.carton_20_kg ?? '0'}">
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      customClass: 'swal-orders',
      focusConfirm: false,
      // Pre-confirm function to gather form values before submission
      preConfirm: () => {
        // Get all form field values
        const cellophane = document.getElementById('cellophane').value;
        const scotch = document.getElementById('scotch').value;
        const pl_10_kg = document.getElementById('pl_10_kg').value;
        const pl_20_kg = document.getElementById('pl_20_kg').value;
        const carton_10_kg = document.getElementById('carton_10_kg').value;
        const carton_20_kg = document.getElementById('carton_20_kg').value;

        // Return all values including comments
        return {
          cellophane,
          scotch,
          pl_10_kg,
          pl_20_kg,
          carton_10_kg,
          carton_20_kg,
        };
      },
    });

    // If user confirmed and provided values, proceed with update
    if (formValues) {
      // Make API call to update Consumables items
      axios
        .post(`/daily-report/update-comsumble/${daily_id}`, formValues, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          // Check if update was successful
          if (response.data.code === 200) {
            // Update the local state with new values
            setValue((prev) => ({
              ...prev,
              valuess: {
                ...prev.valuess,
                cellophane: formValues.cellophane || prev.valuess?.cellophane || '0',
                scotch: formValues.scotch || prev.valuess?.scotch || '0',
                pl_10_kg: formValues.pl_10_kg || prev.valuess?.pl_10_kg || '0',
                pl_20_kg: formValues.pl_20_kg || prev.valuess?.pl_20_kg || '0',
                carton_10_kg: formValues.carton_10_kg || prev.valuess?.carton_10_kg || '0',
                carton_20_kg: formValues.carton_20_kg || prev.valuess?.carton_20_kg || '0',
              },
            }));

            // Show success message
            Swal.fire('Updated!', 'Daily report Consumables updated successfully.', 'success');

            // Refresh the entire daily report data to ensure consistency
            axios
              .get(`/daily-report/listing-new-details/${id}`, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                if (response.data.code === 200) {
                  // Update both state variables with fresh data
                  setValue(response.data.data);
                  setDaillyreportdata(response.data.data.daily_reports);
                }
              })
              .catch((error) => {
                console.error('Error refreshing data:', error);
              });
          }
        })
        .catch((error) => {
          // Log any errors that occur during the update
          console.error('Error updating Consumables items:', error);
          // Optionally show error message to user
          Swal.fire('Error!', 'Failed to update Consumables items.', 'error');
        });
    }
  };




  const updateComments = async (daily_id) => {
    const comments = value.valuess?.comments || '';

    axios
      .post(
        `/daily-report/update-comments/${daily_id}`,
        { comments },
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          Swal.fire('Updated!', 'Comments updated successfully.', 'success');
        }
      })
      .catch((error) => {
        console.error('Error updating Comments:', error);
        Swal.fire('Error!', 'Failed to update Comments.', 'error');
      });
  };





  const updateDateA = async (id_report , weight_here) => {
    const { value: date } = await Swal.fire({
      title: 'Update Raw Materials in stock Grade A',
      html: '<input type="text" id="datePicker" value='+weight_here+' class="swal2-input">',
      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      preConfirm: () => {
        return document.getElementById('datePicker').value;
      }
    });
    if (date) {
      console.log('Selected date:', date);
      axios.get(`/daily-report/update-rm-a/${id_report}/${date}`, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
        .then((response) => {
          console.log(response);
          if (response.data.code === 200) {
            Swal.fire(
              'Success!',
              'Date Updated Successfully.',
              'success'
            );
            axios
              .get(`/daily-report/listing-new-details/${id}`, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                if (response.data.code === 200) {
                  setValue(response.data.data);
                  setDaillyreportdata(response.data.data.daily_reports);
                }
              })
              .catch((error) => {
                console.error('Error refreshing data:', error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

  }

  

  const updateDateB = async (id_report,weight_here) => {
    const { value: date } = await Swal.fire({
      title: 'Update Raw Materials in stock Grade A',
      html: '<input type="text" id="datePicker" value='+weight_here+'  class="swal2-input">',
      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      preConfirm: () => {
        return document.getElementById('datePicker').value;
      }
    });
    if (date) {
      console.log('Selected date:', date);
      axios.get(`/daily-report/update-rm-b/${id_report}/${date}`, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
        .then((response) => {
          console.log(response);
          if (response.data.code === 200) {
            Swal.fire(
              'Success!',
              'Date Updated Successfully.',
              'success'
            );
            axios
              .get(`/daily-report/listing-new-details/${id}`, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                if (response.data.code === 200) {
                  setValue(response.data.data);
                  setDaillyreportdata(response.data.data.daily_reports);
                }
              })
              .catch((error) => {
                console.error('Error refreshing data:', error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

  }


  const updateDateTotal = async (id_report,weight_here) => {
    const { value: date } = await Swal.fire({
      title: 'Update Raw Materials in stock Grade A',
      html: '<input type="text" id="datePicker" value='+weight_here+'  class="swal2-input">',
      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      preConfirm: () => {
        return document.getElementById('datePicker').value;
      }
    });
    if (date) {
      console.log('Selected date:', date);
      axios.get(`/daily-report/update-rm-total/${id_report}/${date}`, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
        .then((response) => {
          console.log(response);
          if (response.data.code === 200) {
            Swal.fire(
              'Success!',
              'Date Updated Successfully.',
              'success'
            );
            axios
              .get(`/daily-report/listing-new-details/${id}`, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                if (response.data.code === 200) {
                  setValue(response.data.data);
                  setDaillyreportdata(response.data.data.daily_reports);
                }
              })
              .catch((error) => {
                console.error('Error refreshing data:', error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

  }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Daily Report Group By Date, Shift, Location and Product</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/dailyreports">Daily Reports</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View  Daily Report
                    </li>
                  </ul>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title text-center">Production Daily Report Group By Date, Shift, Location and Product </h4><hr /> <br />
                    <div style={{ float: "right" }}>

                      <button onClick={() => handleDownload()} className="btn btn-primary me-1"  > Download Daily  <i className="fa fa-print" />  </button>
                    </div>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th className="p-3">Production Manager</th>
                          <td className="p-3">{value.valuess ? value.valuess.production_manager : ""}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Shift Date</th>
                          <td className="p-3">{value.para ? value.para.date : ""}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Shift</th>
                          <td className="p-3">{value.para ? value.para.shift : ""}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Location</th>
                          <td className="p-3">
                            {value.para ? value.para.location_name : ""}
                          </td>
                        </tr>

                        <tr>
                          <th className="p-3">Product</th>
                          <td className="p-3">{value.para ? value.para.product : ""}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>



            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title text-center">Stock Managment </h4> <hr /> <br />


                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th className="p-3">RM Received Grade A</th>
                          <td className="p-3">{daillyreportdata.sec1 ? daillyreportdata.sec1.a : ""}</td>
                        </tr>
                        <tr>
                          <th className="p-3">RM Received Grade B</th>
                          <td className="p-3">{daillyreportdata.sec1 ? daillyreportdata.sec1.b : ""}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Total of reception</th>
                          <td className="p-3">{daillyreportdata.sec1 ? daillyreportdata.sec1.a_b : ""}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Raw Materials in stock Grade A</th>
                          <td className="p-3">
                            <button className="btn btn-primary btn-block" onClick={() => updateDateA(value.valuess.id, value.valuess.rm_stock_material_grade_a)}  > {value.valuess ? value.valuess.rm_stock_material_grade_a : 0} </button>



                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Raw Materials in stock Grade B</th>

                          <td className="p-3">
                            <button className="btn btn-primary btn-block" onClick={() => updateDateB(value.valuess.id, value.valuess.rm_stock_material_grade_b)}  >{value.valuess ? value.valuess.rm_stock_material_grade_b : 0}</button>

                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Total Raw material in stock</th>
                          <td className="p-3">
                            <button className="btn btn-primary btn-block" onClick={() => updateDateTotal(value.valuess.id, value.valuess.rm_stock_material_grade_total)}  > {value.valuess ? value.valuess.rm_stock_material_grade_total : 0} </button>

                          </td>
                        </tr>

                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title text-center">Production Management </h4> <hr /> <br />
                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      <table className="table table-bordered">
                        <thead>
                          <tr className="newtable-heading">
                            <td className="p-3 ">Supplier</td>
                            <td className="p-3 text-center">Lot Number</td>
                            <td className="p-3 text-center">Net Weight Grade A</td>
                            <td className="p-3 text-center">Net Weight Grade B</td>
                            <td className="p-3 text-center">S.F Grade A</td>
                            <td className="p-3 text-center">% S.F Grade A</td>
                            <td className="p-3 text-center">S.F Grade B</td>
                            <td className="p-3 text-center">S.F Grade Puree</td>
                          </tr>
                        </thead>
                        <tbody>
                          {daillyreportdata.sec12 && daillyreportdata.sec12.map((item, index) => (
                            <tr key={index}>
                              <td className="p-3 ">{item.supplier}</td>
                              <td className="p-3 text-center">{item.lot_number}</td>
                              <td className="p-3 text-center">{item.grade_a_feed}</td>
                              <td className="p-3 text-center">{item.grade_b_feed}</td>
                              <td className="p-3 text-center">{item.semi_a}</td>
                              <td className="p-3 text-center">{item.semi_a_percentage} %</td>
                              <td className="p-3 text-center">{item.semi_b}</td>
                              <td className="p-3 text-center">{item.semi_puree}</td>


                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <hr />
                    <div className="row" >

                      <div className="col-xl-6 col-sm-6 col-12">
                        <div className="row" >
                          <div className="col-xl-12 col-sm-12 col-12">
                            <div className="card dashboard-card-border">
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                                    <div className="dash-widget-header" style={{ padding: '20px 10px' }}>
                                      <span className="dash-widget-icon bg-site3">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">Total Net Weight Grade A </div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_grade_a_feed : ""}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                                    <div className="dash-widget-header" style={{ padding: '20px 10px' }}>
                                      <span className="dash-widget-icon bg-site2">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">Total Net Weight Grade B</div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_grade_b_feed : ""}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                                    <div className="dash-widget-header " style={{ padding: '20px 10px' }}>
                                      <span className="dash-widget-icon bg-site2">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">Total consommation</div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_grade_a_b_feed : ""}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="col-xl-6 col-md-6 col-sm-12 col-12">
                        <div className="row" >
                          <div className="col-xl-12 col-sm-12 col-12">
                            <div className="card dashboard-card-border" style={{ padding: '5px', marginBottom: '10px' }}>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-xl-6 col-sm-6 col-12">
                                    <div className="dash-widget-header">
                                      <span className="dash-widget-icon bg-site3">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">Total Semi Finished Grade A </div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_a : ""}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-sm-6 col-12">
                                    <div className="dash-widget-header">
                                      <span className="dash-widget-icon bg-site2">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">% Grade A</div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_a_per : ""} %</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>

                          <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                            <div className="card dashboard-card-border" style={{ padding: '5px', marginBottom: '10px' }}>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-xl-6 col-sm-6 col-12">
                                    <div className="dash-widget-header">
                                      <span className="dash-widget-icon bg-site3">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">Total Semi Finished Grade B </div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_b : ""}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-sm-6 col-12">
                                    <div className="dash-widget-header">
                                      <span className="dash-widget-icon bg-site2">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">% Grade B</div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_b_per : ""} %</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>

                          <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                            <div className="card dashboard-card-border" style={{ padding: '5px', marginBottom: '10px' }}>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-xl-6 col-sm-6 col-12">
                                    <div className="dash-widget-header">
                                      <span className="dash-widget-icon bg-site3">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">Total Semi Finished Puree </div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_puree : ""}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-sm-6 col-12">
                                    <div className="dash-widget-header">
                                      <span className="dash-widget-icon bg-site2">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">% Puree</div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_puree_per : ""} %</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>
                          <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                            <div className="card dashboard-card-border" style={{ padding: '5px', marginBottom: '10px' }}>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-xl-6 col-sm-6 col-12">
                                    <div className="dash-widget-header">
                                      <span className="dash-widget-icon bg-site3">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">Total Semi Finished </div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_a_b_puree : ""}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-sm-6 col-12">
                                    <div className="dash-widget-header">
                                      <span className="dash-widget-icon bg-site2">
                                        <i className="fa fa-balance-scale	"></i>
                                      </span>
                                      <div className="dash-count">
                                        <div className="dash-title">Semi finished Output</div>
                                        <div className="dash-counts">
                                          <p>{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_a_b_puree_per : ""} %</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>

                        </div>

                      </div>







                    </div>
                    {/* <table className="table table-bordered">
                      <tr>
                        <th className="p-3 ">Total Net Weight Grade A</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_grade_a_feed : ""}</td>
                      </tr>

                      <tr>
                        <th className="p-3 ">Total Net Weight Grade B</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_grade_b_feed : ""}</td>
                      </tr>
                      <tr>
                        <th className="p-3 ">Total consommation </th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_grade_a_b_feed : ""}</td>
                      </tr>
                      <tr>
                        <th className="p-3 ">Total Semi Finished Grade A</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_a : ""}</td>
                      </tr>
                      <tr>
                        <th className="p-3 ">Total Semi Finished Grade B</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_b : ""}</td>
                      </tr>
                      <tr>
                        <th className="p-3 ">Total Semi Finished Puree</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_puree : ""}</td>
                      </tr>
                      <tr>
                        <th className="p-3 ">Total Semi Finished</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_a_b_puree : ""}</td>
                      </tr>
                      <tr>
                        <th className="p-3 ">% Grade A</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_a_per : ""}%</td>
                      </tr>
                      <tr>
                        <th className="p-3 ">% Grade B</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_b_per : ""}%</td>
                      </tr>
                      <tr>
                        <th className="p-3 ">% Grade Puree</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_puree_per : ""}%</td>
                      </tr>

                      <tr>
                        <th className="p-3 ">Rendement semi finished</th>
                        <td className="p-3 ">{daillyreportdata.sec12_result ? daillyreportdata.sec12_result.sum_semi_a_b_puree_per : ""}%</td>
                      </tr>
                    </table> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title text-center">Finished Product Management  </h4> <hr /> <br />

                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3 ">
                          <table className="table table-bordered">


                            <tr>
                              <th className="p-3 text-center" colSpan={2}><h5>Processed Material</h5></th>
                            </tr>
                            <tr className="newtable-heading">
                              <th className="p-3 "> Type</th>

                              <th className="p-3 text-center"> Net Weight</th>
                            </tr>
                            <tr>
                              <th className="p-3 ">Garde A</th>
                              <td className="p-3 ">{daillyreportdata.sec3 ? daillyreportdata.sec3.feed_A : ""}</td>
                            </tr>
                            <tr>
                              <th className="p-3 ">Garde B</th>
                              <td className="p-3 ">{daillyreportdata.sec3 ? daillyreportdata.sec3.feed_B : ""}</td>
                            </tr>
                            <tr>
                              <th className="p-3 ">Puree</th>
                              <td className="p-3 ">{daillyreportdata.sec3 ? daillyreportdata.sec3.feed_Puree : ""}</td>
                            </tr>
                            <tr>
                              <th className="p-3 ">Total Quantity Processed</th>
                              <td className="p-3 ">{daillyreportdata.sec3 ? daillyreportdata.sec3.feed_total : ""}</td>
                            </tr>

                          </table>
                        </th>
                        <td className="p-3 ">
                          <table className="table table-bordered">

                            <tr>
                              <th className="p-3 text-center" colSpan={4}><h5>Finished Product</h5></th>
                            </tr>
                            <tr className="newtable-heading">
                              <th className="p-3 "> Type</th>
                              <th className="p-3 text-center"> Number Of Boxes</th>
                              <th className="p-3 text-center"> Packaging Type</th>
                              <th className="p-3 text-center"> Total</th>
                            </tr>
                            <tr>
                              <td className="p-3 "> Grade A		</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Grade_A.boxes : "0"}</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Grade_A.packing : "0"}</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Grade_A.total : "0"}</td>
                            </tr>

                            <tr>
                              <td className="p-3 "> Grade B		</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Grade_B.boxes : "0"}</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Grade_B.packing : "0"}</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Grade_B.total : "0"}</td>
                            </tr>

                            <tr>
                              <td className="p-3 "> Crumble		</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Crumble.boxes : "0"}</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Crumble.packing : "0"}</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Crumble.total : "0"}</td>
                            </tr>

                            <tr>
                              <td className="p-3 "> Puree		</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Puree.boxes : "0"}</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Puree.packing : "0"}</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.Puree.total : "0"}</td>
                            </tr>

                            <tr>
                              <td colSpan={3} className="p-3 "> Total		</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.allgrade_sum : "0"}</td>
                            </tr>
                            <tr>
                              <td colSpan={3} className="p-3 "> Finished Product output		</td>
                              <td className="p-3 text-center"> {daillyreportdata.sec33 ? daillyreportdata.sec33.pf_percentage : "0"}%</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>

                    {/* <ul className="nav nav-tabs nav-tabs-bottom">

                      <li className="nav-item">
                        <a className="nav-link active" href="#tab-1" data-bs-toggle="tab">Processed Material</a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#tab-2" data-bs-toggle="tab"> Finished Product</a>
                      </li>


                    </ul>
                    <div className="tab-content">

                      <div className="tab-pane show active" id="tab-1">
                        <div className="row"  >
                          <div className="col-sm-12" >
                            <div className="card card-table">
                              <div className="card-body">
                                <div className="table-responsive">


                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane " id="tab-2">
                        <div className="row" >
                          <div className="col-sm-12">
                            <div className="card card-table">
                              <div className="card-body">
                                <div className="table-responsive">


                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
 */}



                  </div>
                </div>
              </div>
            </div>



            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title text-center">Non-Conform Product   </h4> <hr /> <br />
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="p-3"> Grade A </th>
                          <th className="p-3"> Grade B</th>
                          <th className="p-3">Crumble </th>
                          <th className="p-3">Puree</th>
                          <th className="p-3">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="p-3">
                            {value.valuess?.grade_a ? Number(value.valuess.grade_a).toFixed(1) : "0"}
                          </td>
                          <td className="p-3">
                            {value.valuess?.grade_a ? Number(value.valuess.grade_b).toFixed(1) : "0"}
                          </td>
                          <td className="p-3">
                            {value.valuess?.grade_a ? Number(value.valuess.crumble).toFixed(1) : "0"}
                          </td>
                          <td className="p-3">
                            {value.valuess?.grade_a ? Number(value.valuess.puree).toFixed(1) : "0"}
                          </td>

                          <td className="p-3">
                            <button
                              className="btn btn-primary"
                              onClick={() => updateNonConform(value.valuess?.id)}
                            >
                              Update
                            </button>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title text-center">Conform Product  </h4> <hr /> <br />
                    <table className="table table-bordered">
                      <thead>
                        <th className="p-3"> Grade A </th>
                        <th className="p-3"> Grade B</th>
                        <th className="p-3">Crumble </th>
                        <th className="p-3">Puree</th>
                      </thead>
                      <tbody>
                        <tr>
                          {/* <td className="p-3"> {daillyreportdata.sec5 ? daillyreportdata.sec5.finished_a : ""}</td>
                          <td className="p-3"> {daillyreportdata.sec5 ? daillyreportdata.sec5.finished_b : ""}</td>
                          <td className="p-3"> {daillyreportdata.sec5 ? daillyreportdata.sec5.finished_crumble : ""}</td>
                          <td className="p-3"> {daillyreportdata.sec5 ? daillyreportdata.sec5.finished_puree : ""}</td> */}

                          <td className="p-3"> {daillyreportdata.new_finished_product ? daillyreportdata.new_finished_product.grade_a : ""}</td>
                          <td className="p-3"> {daillyreportdata.new_finished_product ? daillyreportdata.new_finished_product.grade_b : ""}</td>
                          <td className="p-3"> {daillyreportdata.new_finished_product ? daillyreportdata.new_finished_product.crumble : ""}</td>
                          <td className="p-3"> {daillyreportdata.new_finished_product ? daillyreportdata.new_finished_product.puree : ""}</td>


                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title text-center">Consumables   </h4> <hr /> <br />
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="p-3"> Cellophane </th>
                          <th className="p-3"> Scotch</th>
                          <th className="p-3">PL 10 KG </th>
                          <th className="p-3">PL 20 KG</th>
                          <th className="p-3">Carton 10 KG</th>
                          <th className="p-3">Carton 20 KG</th>
                          <th className="p-3">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="p-3">
                            {value.valuess?.cellophane ? value.valuess.cellophane : "0"}
                          </td>
                          <td className="p-3">
                            {value.valuess?.scotch ? value.valuess.scotch : "0"}
                          </td>
                          <td className="p-3">
                            {value.valuess?.pl_10_kg ? value.valuess.pl_10_kg : "0"}
                          </td>
                          <td className="p-3">
                            {value.valuess?.pl_20_kg ? value.valuess.pl_20_kg : "0"}
                          </td>
                          <td className="p-3">
                            {value.valuess?.carton_10_kg ? value.valuess.carton_10_kg : "0"}
                          </td>
                          <td className="p-3">
                            {value.valuess?.carton_20_kg ? value.valuess.carton_20_kg : "0"}
                          </td>


                          <td className="p-3">
                            <button
                              className="btn btn-primary"
                              onClick={() => updateConsumables(value.valuess?.id)}
                            >
                              Update
                            </button>
                          </td>
                        </tr>
                        <tr className="newtable-heading">
                          <th colSpan={7} className="p-3 text-center">
                            Comments
                          </th>

                        </tr>
                        <tr>
                          <td colSpan={6} className="p-3 text-center">
                            <textarea
                              className="form-input form-control"
                              value={value.valuess?.comments || ''}
                              onChange={(e) =>
                                setValue((prev) => ({
                                  ...prev,
                                  valuess: {
                                    ...prev.valuess,
                                    comments: e.target.value,
                                  },
                                }))
                              }
                            />
                          </td>

                          <td className="p-3 text-center">
                            <button
                              className="btn btn-primary"
                              onClick={() => updateComments(value.valuess?.id)}
                            >
                              Update
                            </button>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ProductionDailyReportView;
